var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDragHandle = function SvgDragHandle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M5 10.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 4.25 10c0-.213.072-.391.216-.535A.726.726 0 0 1 5 9.25h14c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H5Zm0 4a.725.725 0 0 1-.534-.216A.726.726 0 0 1 4.25 14c0-.213.072-.391.216-.535A.726.726 0 0 1 5 13.25h14c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H5Z",
    fill: "currentColor"
  })));
};
export default SvgDragHandle;